export interface RepeatedClickConfiguration {
    count: number;
    withinMs: number;
    ignoredTargetsSelector?: string;
    onRepeatedClick: () => void;
}

export function repeatedClick(elem: HTMLElement, config: RepeatedClickConfiguration) {
    let currentConfig: RepeatedClickConfiguration = config;
    let clickTimes: number[] = [];

    const handleClick = (event: MouseEvent) => {
        const {count, withinMs, ignoredTargetsSelector, onRepeatedClick} = currentConfig;
        if (ignoredTargetsSelector !== undefined && event.target instanceof Element && event.target.closest(ignoredTargetsSelector) !== null) {
            return;
        }
        const now = Date.now();
        clickTimes = [...clickTimes.filter((clickTime) => now - clickTime < withinMs), now];
        if (clickTimes.length >= count) {
            clickTimes = [];
            onRepeatedClick();
        }
    };

    elem.addEventListener('click', handleClick);

    return {
        update: (updated: RepeatedClickConfiguration) => {
            currentConfig = updated;
        },
        destroy: () => {
            elem.removeEventListener('click', handleClick);
        }
    };
}
